export type AnnouncementsLoadStatus = 'idle' | 'loading' | 'loaded';

export interface AnnouncementsState {
    /** All ids the server says this user is currently eligible to see. */
    eligibleIds: string[];
    /** The id picked from `eligibleIds` for current rendering, if any. */
    currentId: string | undefined;
    loadStatus: AnnouncementsLoadStatus;
}

export const initialAnnouncementsState: AnnouncementsState = {
    eligibleIds: [],
    currentId: undefined,
    loadStatus: 'idle',
};
